import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css'
import MainScreen from './screens/MainScreen';
import AboutUsScreen from './screens/AboutUsScreen';
import MenuScreen from './screens/MenuScreen';
import BookScreen from './screens/BookScreen';
import BookRoomsScreen from './screens/BookRoomsScreen';
import RoomsScreen from './screens/RoomsScreen';
import GalleryScreen from './screens/GalleryScreen';
import EventScreen from './screens/EventScreen';
import RecreationScreen from './screens/RecreationScreen';

function App() {
  return (
    <div style={{width: '100%'}}>
      <Routes>
        <Route path='/' element={<MainScreen />} />
        <Route path='/aboutus' element={<AboutUsScreen />} />
        <Route path='/menu' element={<MenuScreen />} />
        <Route path='/book' element={<BookScreen />} />
        <Route path='/bookrooms' element={<BookRoomsScreen />} />
        <Route path='/rooms' element={<RoomsScreen />} />
        <Route path='/gallery' element={<GalleryScreen />} />
        <Route path='/event' element={<EventScreen />} />
        <Route path='/Recreation' element={<RecreationScreen />} />
      </Routes>
    </div>
  );
}

export default App;
